module.exports = __webpack_public_path__ + "img/19exp.921de559.jpg";